<template>
  <!-- <div
    class="c-header u-bg-yellow -contain"
    :style="{
      'background-image':
        'url(' + require('@arag/assets/img/header/icon_mental.svg') + ')',
    }"
  >
    <img class="c-header__logo" width="40" src="@/assets/img/arag_logo.png" />
  </div> -->
  <Header
    class="u-bg-yellow -contain"
    headline="Bei mentalen Beschwerden unterstützen Sie die ARAG Gesundheitsassistenten."
    :image="require('@arag/assets/img/header/icon_mental.svg')"
    :logo="require('@/assets/img/arag_logo.png')"
    logoWidth="40"
    hideButton
  />
  <p class="ion-padding-top">
    <b>
      <span class="ion-hide-lg-up"
        >Bei mentalen Beschwerden unterstützen Sie die ARAG
        Gesundheitsassistenten.<br
      /></span>
      Schon bei ersten Anzeichen einer psychischen Belastung, helfen Ihnen die
      fachkundigen Partner der ARAG:
    </b>
  </p>
  <!-- <p>
    <img src="@/assets/img/selfapy_logo.svg" width="100" />
    <br />
    Online-Programm mit telefonischer Begleitung ermöglicht Hilfe zur
    Selbsthilfe – mit von Psychotherapeuten entwickelten Inhalten zu Depression,
    Angst & Panik und Essstörungen.
  </p> -->
  <p class="ion-padding-top">
    <img src="@/assets/img/therapeutenverbund_logo.jpg" width="200" />
    <br />
    Besonders schneller Zugang zu einem Therapieplatz – meist schon innerhalb
    von 10 Tagen.
  </p>
  <p class="ion-padding-top">
    <img src="@/assets/img/minddoc_logo.svg" width="100" />
    <br />
    Video-gestützte Online-Therapie mit erfahrenen Psychotherapeuten in
    wöchentlichen Video-Sitzungen.
  </p>
  <!-- <div class="c-line"></div> -->
  <ion-row class="ion-align-items-center">
    <ion-col>
      <ion-button
        size="small"
        fill="clear"
        class="ion-text-wrap ion-no-padding"
        @click="openKostenerstattungModal"
        >Kostenrückerstattung&nbsp;
        <ion-icon :icon="helpCircle" />
      </ion-button>
    </ion-col>
    <!-- <ion-col class="ion-text-right">
      <img width="50" src="@/assets/img/arag_logo.png" />
    </ion-col> -->
  </ion-row>
</template>

<script>
import { helpCircle } from "ionicons/icons";
import KostenerstattungModal from "@arag/components/KostenerstattungAragMentalModal";
import {
  IonButton,
  IonIcon,
  modalController,
  IonRow,
  IonCol,
} from "@ionic/vue";
import Header from "@/components/Header";

export default {
  components: {
    IonButton,
    IonIcon,
    IonRow,
    IonCol,
    Header,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
    };
  },
};
</script>

<style></style>
